import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import estilos from '../PanelDetalleCliente/PanelDictamenesComponent.module.css';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Typography, TextField, MenuItem, Button, Autocomplete, InputLabel, ListSubheader, FormControl, Select, OutlinedInput } from '@mui/material';
import moment from 'moment'
import BotonVerDictamenesComponent from './BotonVerDictamenesComponent';
import {
    AgregarDictamenJuridico, obtenerDictamenJuridico, ActualizarDictamenJuridico,
    obtenerDictamenesJuridicoByYear, obtenerFolioDictamen, actualizarFolioOficioDictamen
} from '../../../../redux/DucksAtencionACliente/UsuariosAtencionAClienteDuck';
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../../redux/AppDucks';

function DictamenJuridicoComponent(props) {
    const fechaHoy = moment().format('YYYY-MM-DD')
    const dispatch = useDispatch();

    const solicitud = useSelector(store => store.UsuariosAtencionACliente.informacionClienteDictamen)

    const [tiposociedad, setTipoSociedad] = React.useState('')
    const [fechasolicitud, setFechaSolicitud] = React.useState(fechaHoy)
    const [fechaconstitucion, setFechaConstitucion] = React.useState('')
    const [duracionsociedad, setDuracionSociedad] = React.useState('')
    const [documento, setDocumento] = React.useState('')
    const [documentofecha, setDocumentoFecha] = React.useState('')
    const [numeroinstrumento, setNumeroInstumento] = React.useState('')
    const [volumen, setVolumen] = React.useState('')
    const [numeronotario, setNumeroNotario] = React.useState('')
    const [nombrenotario, setNombreNotario] = React.useState('')
    const [datossociedad, setDatosSociedad] = React.useState('El Acta Constitutiva está inscrita bajo el numero FME-12345, del Registro Público de Comercio del Estado de Oaxaca, con fecha 01/01/2023.')
    const [organorepresentacion, setOrganoRepresentacion] = React.useState('')
    const [duracionorgano, setDuracionOrgano] = React.useState('')
    const [representanteapoderado, setRepresentanteApoderado] = React.useState('')
    const [cargorepresentante, setCargoRepresentante] = React.useState('')
    const [vigenciarepresentante, setVigenciaRepresentante] = React.useState('')
    const [analisisjuridico, setAnalisisJuridico] = React.useState('')

    const [conclusion, setConclusion] = React.useState('Por ello es de concluirse que la persona moral denominada ' + solicitud?.nombrerazonsocial + ', existe y es valido jurídicamente, y al estar inscrito en el Registro Publico de Comercio tiene personalidad jurídica propia.')
    //const [domicilio, setDomicilio] = React.useState(solicitud?.domiciliofiscalcliente?.[0]?.municipioalcaldia + ", " + solicitud?.domiciliofiscalcliente?.[0]?.estado + ". ")
    const [domicilio, setDomicilio] = React.useState('')

    const [isDictamen, setIsDictamen] = React.useState(false)
    const [resultado, setResultado] = React.useState([])

    const [openModal, setOpenModal] = React.useState(false)
    const [titleModal, setTitleModal] = React.useState('')
    const [bodyModal, setBodyModal] = React.useState('')
    const closeModal = () => setOpenModal(false)

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        border: 'none',
        boxShadow: 24,
        p: 4,
    };

    const tipoSociedadArray = [
        { title: 'Sociedad anónima de capital variable' },
        { title: 'Sociedad de responsabilidad limitada de capital variable' },
        { title: 'Sociedad de responsabilidad limitada microindustrial' },
        { title: 'Sociedad de producción rural de responsabilidad limitada' },
        { title: 'Sociedad por acciones simplificada de capital variable' },
        { title: 'Sociedad anónima promotora de inversión de capital variable' },
        { title: 'Sociedad cooperativa de responsabilidad limitada' }
    ]

    const tipoDocumentoArray = [
        { title: 'Acta constitutiva' },
        { title: 'Acta de asamblea general extraordinaria de accionistas' },
        { title: 'Acta de asamblea general ordinaria de accionistas' },
        { title: 'Contrato social de sociedad por acciones simplificada' },
        { title: 'Acta de asamblea general extraordinaria y ordinaria de socios' }
    ]

    const organoRepresentacionArray = [
        { title: 'Administrador único' },
        { title: 'Consejo de administración' }
    ]

    const cargoRepresentanteArray = [
        { title: 'Administrador único' },
        { title: 'Presidente' },
        { title: 'Gerente general' },
        { title: 'Gerente único' },
        { title: 'Apoderado legal' }
    ]

    const domicilios = []

    solicitud?.domiciliofiscalcliente?.map(dom => {
        domicilios.push(dom.municipioalcaldia + ", " + dom.estado + ". ")
    })

    React.useEffect(async () => {
        let result = await dispatch(obtenerDictamenJuridico(solicitud?.idcliente))

        if (result?.payload?.length > 0) {
            setTipoSociedad(result?.payload?.[0]?.tiposociedad)
            setFechaSolicitud(moment(result?.payload?.[0]?.fechasolicitud).add(1, 'd').format('YYYY-MM-DD'))
            setFechaConstitucion(moment(result?.payload?.[0]?.fechaconstitucion).add(1, 'd').format('YYYY-MM-DD'))
            setDuracionSociedad(result?.payload?.[0]?.duracionsociedad)
            setDocumento(result?.payload?.[0]?.documento)
            setDocumentoFecha(moment(result?.payload?.[0]?.documentofecha).add(1, 'd').format('YYYY-MM-DD'))
            setNumeroInstumento(result?.payload?.[0]?.numeroinstrumento)
            setVolumen(result?.payload?.[0]?.volumen)
            setNumeroNotario(result?.payload?.[0]?.numeronotario)
            setNombreNotario(result?.payload?.[0]?.nombrenotario)
            setDatosSociedad(result?.payload?.[0]?.datossociedad)
            setOrganoRepresentacion(result?.payload?.[0]?.organorepresentacion)
            setDuracionOrgano(result?.payload?.[0]?.duracionorgano)
            setRepresentanteApoderado(result?.payload?.[0]?.representantelegal)
            setCargoRepresentante(result?.payload?.[0]?.cargorepresentante)
            setVigenciaRepresentante(result?.payload?.[0]?.vigenciarepresentante)
            setConclusion(result?.payload?.[0]?.conclusion)
            setDomicilio(result?.payload?.[0]?.domiciliosocial)
            setIsDictamen(true)
            setResultado(result?.payload?.[0])
        }
    }, [])

    const GenerarDictamenJuridico = async () => {

        if (tiposociedad == '' || fechaconstitucion == '' || duracionsociedad == '' || documento == '' || documentofecha == '' ||
            numeroinstrumento == '' || volumen == '' || numeronotario == '' || nombrenotario == '' || duracionorgano == '' ||
            representanteapoderado == '' || cargorepresentante == '' || vigenciarepresentante == '' || analisisjuridico == '') {
            setTitleModal("¡Alerta!")
            setBodyModal("Debe de rellenar todos los campos para poder generar el Dictamen Jurídico.")
            setOpenModal(true)
        } else {
            await dispatch(actualizarLoadingApp_true())
            var año = moment().format('YYYY');
            let year = String(año)
            let contadorFolio = await dispatch(obtenerDictamenesJuridicoByYear(year))
            let folio = '0001'
            if (contadorFolio?.payload > 0) {
                let obtenerFolio = await dispatch(obtenerFolioDictamen(2))
                const nuevoFolio = ('000' + (parseInt(obtenerFolio?.payload?.folio, 10) + 1)).slice(-4)
                folio = nuevoFolio
            }

            let datesolicitud = new Date(fechasolicitud).toISOString()
            let dateContitucion = new Date(fechaconstitucion).toISOString()
            let dateDocumento = new Date(documentofecha).toISOString()

            //setDomicilio(domicilios.join(''))
            let domicilioSocial = domicilios.join('')
            if (!isDictamen) {
                let dataJuridico = {
                    fechasolicitud: datesolicitud, numeroinforme: 'DJ-' + folio + '/' + year, nombrerazonsocial: solicitud?.nombrerazonsocial,
                    tiposociedad: tiposociedad, fechaconstitucion: dateContitucion,
                    duracionsociedad: duracionsociedad, domiciliosocial: domicilioSocial,
                    documento: documento, documentofecha: dateDocumento, numeroinstrumento: numeroinstrumento,
                    volumen: volumen, numeronotario: numeronotario, nombrenotario: nombrenotario,
                    datossociedad: datossociedad, organorepresentacion: organorepresentacion, duracionorgano: duracionorgano,
                    representantelegal: representanteapoderado, cargorepresentante: cargorepresentante,
                    vigenciarepresentante: vigenciarepresentante, analisisjuridico: analisisjuridico,
                    conclusion: conclusion, idcliente: solicitud?.idcliente
                }
                let resultado = await dispatch(AgregarDictamenJuridico(dataJuridico))
                setIsDictamen(true)
                setResultado(resultado?.payload)

                setTitleModal("Nuevo dictamen.")
                setBodyModal("El Dictamen Jurídico se generó correctamente.")
                setOpenModal(true)
            } else {
                let dataJuridico = {
                    fechasolicitud: datesolicitud, numeroinforme: 'DJ-' + folio + '/' + year, nombrerazonsocial: solicitud?.nombrerazonsocial,
                    tiposociedad: tiposociedad, fechaconstitucion: dateContitucion,
                    duracionsociedad: duracionsociedad, domiciliosocial: domicilioSocial,
                    documento: documento, documentofecha: dateDocumento, numeroinstrumento: numeroinstrumento,
                    volumen: volumen, numeronotario: numeronotario, nombrenotario: nombrenotario,
                    datossociedad: datossociedad, organorepresentacion: organorepresentacion, duracionorgano: duracionorgano,
                    representantelegal: representanteapoderado, cargorepresentante: cargorepresentante,
                    vigenciarepresentante: vigenciarepresentante, analisisjuridico: analisisjuridico,
                    conclusion: conclusion, idcliente: solicitud?.idcliente, iddictamenjuridicocliente: resultado?.iddictamenjuridicocliente
                }
                await dispatch(ActualizarDictamenJuridico(dataJuridico))

                setTitleModal("Actualización.")
                setBodyModal("El Dictamen Jurídico se actualizó correctamente.")
                setOpenModal(true)
            }
            await dispatch(actualizarFolioOficioDictamen({ idfoliodictamen: 2, folio: folio }))
            await dispatch(actualizarLoadingApp_false())
        }
    }

    return (
        <div className={`container ${'disabled'}`} disabled={true}>
            <div style={{ textAlign: 'start' }}>
                <BotonVerDictamenesComponent tabla={'documentodictamenjuridico'} nombreId={'idcliente'} idSolicitud={solicitud.idcliente} disabled={resultado?.iddictamenfiscalcliente != null && resultado?.iddictamenfiscalcliente != undefined ? true : false} />
            </div>
            <div className={`mb-3 ${estilos.divSoloBorderNaranja} row mt-3`} style={solicitud?.personafisica ? { pointerEvents: 'none' } : {}}>

                <h3>DICTAMEN JURÍDICO</h3>

                <h5 className='mt-5'><b>Datos de la sociedad</b></h5>

                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Fecha de solicitud" variant="outlined" style={{ width: '100%' }} type='date'
                        //InputProps={{ inputProps: { max: fechaHoy } }}
                        InputLabelProps={{ shrink: true, }} value={fechasolicitud} onChange={e => setFechaSolicitud(e.target.value)} />
                </div>

                <div className="col-md-8 mt-3">
                    <Autocomplete id="free-solo-demo" freeSolo
                        value={tiposociedad}
                        onInputChange={(e, value) => { setTipoSociedad(value); }}
                        options={tipoSociedadArray.map((option) => option.title)} style={{ width: '100%' }}
                        renderInput={(params) => <TextField {...params} label="Tipo de sociedad" />} />
                </div>

                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Fecha de constitución" variant="outlined" style={{ width: '100%' }} type='date'
                        InputLabelProps={{ shrink: true, }} value={fechaconstitucion} onChange={e => setFechaConstitucion(e.target.value)} />
                </div>

                <div className="col-md-8 mt-3">
                    <TextField id="outlined-basic" label="Duración de la sociedad" variant="outlined" style={{ width: '100%' }}
                        value={duracionsociedad} onChange={e => setDuracionSociedad(e.target.value)} />
                </div>

                <h5 className='mt-5'><b>Datos del documento</b></h5>

                <div className="col-md-12 mt-3">
                    <Autocomplete id="free-solo-demo" freeSolo
                        value={documento}
                        onInputChange={(e, value) => { setDocumento(value); setAnalisisJuridico(value) }}
                        options={tipoDocumentoArray.map((option) => option.title)} style={{ width: '100%' }}
                        renderInput={(params) => <TextField {...params} label="Tipo de documento" />} />
                </div>

                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="De fecha" variant="outlined" style={{ width: '100%' }} type='date'
                        InputLabelProps={{ shrink: true, }} value={documentofecha} onChange={e => setDocumentoFecha(e.target.value)} />
                </div>

                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Consta con el instrumento N°" variant="outlined" style={{ width: '100%' }}
                        value={numeroinstrumento} onChange={e => setNumeroInstumento(e.target.value)} />
                </div>

                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Volúmen" variant="outlined" style={{ width: '100%' }}
                        value={volumen} onChange={e => setVolumen(e.target.value)} />
                </div>

                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Número del notario público" variant="outlined" style={{ width: '100%' }}
                        value={numeronotario} onChange={e => setNumeroNotario(e.target.value)} />
                </div>

                <div className="col-md-8 mt-3">
                    <TextField id="outlined-basic" label="Nombre del notario público" variant="outlined" style={{ width: '100%' }}
                        value={nombrenotario} onChange={e => setNombreNotario(e.target.value)} />
                </div>

                <div className="col-md-12 mt-3">
                    <TextField id="outlined-basic" label="Datos de registro de la sociedad" variant="outlined" style={{ width: '100%' }}
                        value={datossociedad} onChange={e => setDatosSociedad(e.target.value)} />
                </div>

                <h5 className='mt-5'><b>Organo de Representación</b></h5>

                <div className="col-md-6 mt-3">
                    <Autocomplete id="free-solo-demo" freeSolo
                        value={organorepresentacion}
                        onInputChange={(e, value) => { setOrganoRepresentacion(value); }}
                        options={organoRepresentacionArray.map((option) => option.title)} style={{ width: '100%' }}
                        renderInput={(params) => <TextField {...params} label="Órgano de Representación" />} />
                </div>

                <div className="col-md-6 mt-3">
                    <TextField id="outlined-basic" label="Duración del Órgano de Representación" variant="outlined" style={{ width: '100%' }}
                        value={duracionorgano} onChange={e => setDuracionOrgano(e.target.value)} />
                </div>

                <h5 className='mt-5'><b>Representante legal actual</b></h5>

                <div className="col-md-4 mt-3">
                    <FormControl sx={{ width: '100%', mb: 1 }}>
                        <InputLabel htmlFor="grouped-select">Representante/Apoderado Legal</InputLabel>
                        <Select id="grouped-select" label="Representante/Apoderado Legal"
                            value={representanteapoderado}
                            onChange={e => setRepresentanteApoderado(e.target.value)}>
                            <ListSubheader style={{ fontWeight: 'bold', color: 'black' }}>Representante</ListSubheader>
                            <MenuItem value={solicitud?.nombrerepresentantelegal}> {solicitud?.nombrerepresentantelegal} </MenuItem>
                            <ListSubheader style={{ fontWeight: 'bold', color: 'black' }}> Apoderados </ListSubheader>
                            {solicitud?.apoderadoslegalescliente?.map(apoderado => (
                                <MenuItem value={apoderado.representantelegal}> {apoderado.representantelegal} </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>

                <div className="col-md-4 mt-3">
                    <Autocomplete id="free-solo-demo" freeSolo
                        value={cargorepresentante}
                        onInputChange={(e, value) => { setCargoRepresentante(value); }}
                        options={cargoRepresentanteArray.map((option) => option.title)} style={{ width: '100%' }}
                        renderInput={(params) => <TextField {...params} label="Cargo del Representante/Apoderado Legal" />} />
                </div>

                <div className="col-md-4 mt-3">
                    <TextField id="outlined-basic" label="Vigencia de las facultades del Representante/Apoderado Legal" variant="outlined" style={{ width: '100%' }}
                        value={vigenciarepresentante} onChange={e => setVigenciaRepresentante(e.target.value)} />
                </div>

                <div className="col-md-12 mt-3">
                    <TextField id="outlined-basic" label="Conclusión" variant="outlined" style={{ width: '100%' }}
                        value={conclusion} onChange={e => setConclusion(e.target.value)} />
                </div>

                <div className="col-md-12 mt-3">
                    <Button variant="contained" color="success" onClick={() => GenerarDictamenJuridico()}>  Generar Dictamen Jurídico </Button>
                </div>
            </div>

            <Modal
                open={openModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" style={{ textAlign: 'center' }}>
                        <strong>{titleModal}</strong>
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 3 }} style={{ textAlign: 'center' }}>
                        {bodyModal}
                    </Typography>
                    <Typography sx={{ mt: 5 }} className='text-center'>
                        <button className='btn btn-success' onClick={closeModal} style={{ width: '60%' }} > Aceptar </button>
                    </Typography>
                </Box>
            </Modal>
        </div>
    )
}
export default withRouter(DictamenJuridicoComponent)
